import React from 'react';

import { ContainerHeader } from '~components';
import { faHandHoldingHeart } from '~components/icon';

const DashboardContainer: React.FC = () => {
  return (
    <div className="p-2">
      <ContainerHeader icon={faHandHoldingHeart} iconSize="1x" className="info" dataCy="support-at-home-header">
        Support At Home - DASHBOARD PLACEHOLDER
      </ContainerHeader>
      <div className="sah-container"></div>
    </div>
  );
};

export default DashboardContainer;
